<ix-modal-header>
  {{ 'um.access_requests.grant_modal_title' | translate }}
</ix-modal-header>

<ix-modal-content>
  <ix-typography class="d-block mb-3" format="body">
    {{ 'um.access_requests.grant_modal_text' | translate }}
  </ix-typography>
</ix-modal-content>

<ix-modal-footer>
  <ix-button
    class="dismiss-modal"
    onkeypress=""
    variant="secondary"
    (click)="activeModal.dismiss('cancel')"
    id="grantModalCancelButton">
    {{ 'general.cancel' | translate }}
  </ix-button>
  <ix-button
    variant="primary"
    (click)="confirm()"
    onkeypress=""
    id="grantModalConfirmButton">
    {{ 'um.access_requests.grant_access' | translate }}
  </ix-button>
</ix-modal-footer>

